// Convert FAQ answer text into clickable PDF links
export const addPdfLinks = (html) => {
    if (!html) {
        return "";
    }

    // Parse HTML into a DOM so matching text can be transformed
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(html, "text/html");

    // Collect text nodes that are safe to rewrite
    const walker = parsedDocument.createTreeWalker(
        parsedDocument.body,
        NodeFilter.SHOW_TEXT
    );

    const textNodes = [];

    while (walker.nextNode()) {
        const node = walker.currentNode;
        const parentTag = node.parentElement?.tagName;

        if (!["A", "SCRIPT", "STYLE"].includes(parentTag)) {
            textNodes.push(node);
        }
    }

    const pattern = /alphalinerweekly-\d{4}-\d+(?:\.pdf)?/gi;

    textNodes.forEach((textNode) => {
        const text = textNode.nodeValue;
        // Find newsletter PDF references inside the text
        const matches = [...text.matchAll(pattern)];

        if (matches.length === 0) {
            return;
        }

        const fragment = parsedDocument.createDocumentFragment();
        let lastIndex = 0;

        matches.forEach((match) => {
            const displayName = match[0];
            const matchIndex = match.index;

            fragment.appendChild(
                parsedDocument.createTextNode(
                    text.slice(lastIndex, matchIndex)
                )
            );

            // Build the storage filename used for downloads
            const fileName = displayName.toLowerCase().endsWith(".pdf")
                ? displayName
                : `${displayName}.pdf`;

            const link = parsedDocument.createElement("a");
            link.href = "#";
            link.textContent = displayName;
            link.dataset.pdfFile = fileName;

            fragment.appendChild(link);

            lastIndex = matchIndex + displayName.length;
        });

        fragment.appendChild(
            parsedDocument.createTextNode(text.slice(lastIndex))
        );

        textNode.parentNode.replaceChild(fragment, textNode);
    });

    return parsedDocument.body.innerHTML;
};
